/* FF v15 filters: keep scroll position + open groups on AJAX filter, 8-at-a-time show more, in-group search */
(function(){
  if (window.__ffFilters) return; window.__ffFilters = 1;
  var STEP = 8;
  function q(s, r){ return (r||document).querySelector(s); }
  function qa(s, r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); }
  function scope(el){ return el.closest('dialog') ? 'd' : 's'; }
  function norm(s){ return String(s||'').toLowerCase().replace(/\s+/g,' ').trim(); }

  /* ---------- show more / search ---------- */
  function groupOf(el){ return el.closest('details.facets__panel'); }
  function apply(details){
    if (!details) return;
    var items = qa('li.facets__inputs-list-item', details);
    var wrap = q('.ff-sm', details), btn = q('[data-ff-more]', details);
    var inp = q('.ff-fsearch__input', details), none = q('.ff-fsearch__none', details);
    var term = inp ? norm(inp.value) : '';
    var shown = wrap ? (+wrap.getAttribute('data-ff-shown') || STEP) : items.length;
    var matches = 0;
    items.forEach(function(li, i){
      li.classList.remove('hidden'); li.classList.remove('mobile:hidden');
      var checked = !!q('input:checked', li);
      var vis;
      if (term) { vis = norm(li.textContent).indexOf(term) !== -1; }
      else { vis = (i < shown) || checked; }
      if (vis) matches++;
      li.classList.toggle('ff-hide', !vis);
    });
    if (none) none.hidden = !(term && matches === 0);
    if (btn) {
      var remaining = Math.max(0, items.length - shown);
      var hideBtn = !!term || items.length <= STEP;
      btn.classList.toggle('ff-hide', hideBtn);
      btn.setAttribute('data-label', remaining > 0 ? ('Show more (' + remaining + ')') : 'Show less');
      btn.setAttribute('aria-expanded', remaining > 0 ? 'false' : 'true');
      if (wrap) wrap.setAttribute('data-expanded', remaining > 0 ? 'false' : 'true');
    }
  }
  function applyAll(){ qa('details.facets__panel').forEach(apply); }

  window.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('[data-ff-more]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var d = groupOf(btn), wrap = q('.ff-sm', d);
    var total = qa('li.facets__inputs-list-item', d).length;
    var shown = +wrap.getAttribute('data-ff-shown') || STEP;
    var collapsing = shown >= total;
    var anchor = collapsing ? q('summary', d) : btn, top0 = anchor.getBoundingClientRect().top;
    wrap.setAttribute('data-ff-shown', collapsing ? STEP : shown + STEP);
    apply(d);
    if (collapsing) keep(anchor, top0, 400);
  }, true);

  // in-group search: never let it trigger a filter request or a form submit
  window.addEventListener('input', function(e){
    if (!e.target.classList || !e.target.classList.contains('ff-fsearch__input')) return;
    e.stopPropagation(); apply(groupOf(e.target));
  }, true);
  window.addEventListener('change', function(e){
    if (e.target.classList && e.target.classList.contains('ff-fsearch__input')) { e.stopPropagation(); }
  }, true);
  window.addEventListener('keydown', function(e){
    if (e.key === 'Enter' && e.target.classList && e.target.classList.contains('ff-fsearch__input')) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  /* ---------- keep position + open groups across AJAX filter updates ---------- */
  function scrollables(el){
    var out = [], n = el.parentElement;
    while (n && n !== document.body && n !== document.documentElement) {
      var cs = getComputedStyle(n);
      if (/(auto|scroll)/.test(cs.overflowY) && n.scrollHeight > n.clientHeight + 1) out.push(n);
      n = n.parentElement;
    }
    out.push(document.scrollingElement || document.documentElement);
    return out;
  }
  var stopKeep = 0;
  function keep(anchorOrFn, top0, ms){
    var token = ++stopKeep, t0 = performance.now();
    var userMoved = false;
    function onUser(){ if (performance.now() - t0 > 120) userMoved = true; }
    ['wheel','touchmove','keydown'].forEach(function(ev){ window.addEventListener(ev, onUser, {passive:true, once:true}); });
    (function step(){
      if (token !== stopKeep || userMoved) return;
      var a = typeof anchorOrFn === 'function' ? anchorOrFn() : anchorOrFn;
      if (a && a.isConnected) {
        var delta = a.getBoundingClientRect().top - top0;
        if (Math.abs(delta) > 1) {
          var sc = scrollables(a);
          for (var i = 0; i < sc.length && Math.abs(delta) > 1; i++) {
            var before = sc[i].scrollTop; sc[i].style.scrollBehavior = 'auto'; if (sc[i].scrollTo) sc[i].scrollTo({top: before + delta, behavior: 'instant'}); else sc[i].scrollTop = before + delta;
            delta -= (sc[i].scrollTop - before);
          }
        }
      }
      if (performance.now() - t0 < ms) requestAnimationFrame(step);
    })();
  }

  var pending = null;
  window.addEventListener('change', function(e){
    var t = e.target;
    if (!t || !t.closest || t.classList.contains('ff-fsearch__input')) return;
    var form = t.closest('facets-form-component, .facets');
    if (!form || !t.closest('details.facets__panel, .facets__item')) return;
    var sc = scope(t), id = t.id, li = t.closest('li') || t.closest('details') || t;
    var open = qa('details.facets__panel').filter(function(d){ return d.open; }).map(function(d){ return d.id + '|' + scope(d); });
    var shown = {}, terms = {};
    qa('details.facets__panel').forEach(function(d){
      var k = d.id + '|' + scope(d), w = q('.ff-sm', d), s = q('.ff-fsearch__input', d);
      if (w) shown[k] = w.getAttribute('data-ff-shown'); if (s) terms[k] = s.value;
    });
    pending = { open: open, shown: shown, terms: terms };
    var top0 = li.getBoundingClientRect().top;
    function find(){
      if (li.isConnected && li.getClientRects().length) return li;
      var els = id ? qa('[id="' + id.replace(/"/g,'') + '"]').filter(function(x){ return scope(x) === sc; }) : []; var el = els.filter(function(x){ return x.getClientRects().length; })[0] || els[0];
      return el ? (el.closest('li') || el) : null;
    }
    keep(function(){ restoreState(); return find(); }, top0, 5000);
    var mine = pending; setTimeout(function(){ if (pending === mine) pending = null; }, 5200);
  }, true);

  function restoreState(){
    if (!pending) return;
    qa('details.facets__panel').forEach(function(d){
      var k = d.id + '|' + scope(d);
      if (pending.open.indexOf(k) !== -1 && !d.open) d.open = true;
      var w = q('.ff-sm', d), s = q('.ff-fsearch__input', d);
      if (w && pending.shown[k] && w.getAttribute('data-ff-shown') !== pending.shown[k]) w.setAttribute('data-ff-shown', pending.shown[k]);
      if (s && pending.terms[k] != null && s.value !== pending.terms[k]) s.value = pending.terms[k];
      apply(d);
    });
  }

  // re-apply after any morph of the filter area
  var mo = new MutationObserver(function(){ clearTimeout(mo.t); mo.t = setTimeout(function(){ restoreState(); applyAll(); }, 30); });
  function init(){
    applyAll();
    qa('facets-form-component, .facets-block-wrapper, dialog.facets').forEach(function(n){ mo.observe(n, {childList:true, subtree:true}); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // groups that get re-rendered later (drawer) also need the list rules
  document.addEventListener('toggle', function(e){ if (e.target.matches && e.target.matches('details.facets__panel')) apply(e.target); }, true);
})();
